<template>
  <v-card height="422">
    <v-container>
      <v-row class="white">
        <v-col sm="6" class="border-right pa-0 d-none d-sm-flex">
          <v-img v-if="benefit.url" :src="benefit.url" height="422" />
          <v-img v-else :src="defaultImageSrc" height="422" />
        </v-col>

        <v-col sm="6">
          <v-fab-transition>
            <v-btn
              class="white mr-n2"
              fab
              dark
              absolute
              right
              small
              depressed
              @click="upvote"
            >
              <v-icon v-if="benefit.is_favorite" class="pink--text"
                >favorite</v-icon
              >
              <v-icon v-else class="pink--text">favorite_border</v-icon>
            </v-btn>
          </v-fab-transition>
          <v-card flat>
            <v-card-title>
              <div>
                <h4 class="theme-text text-capitalize">{{ benefit.name }}</h4>
                <div
                  class="font-weight-bold body-2 mb-5 theme-text"
                  v-text="benefit.title"
                />
                <div class="font-weight-bold body-2 mt-5">
                  Offer description
                </div>
                <div class="body-2 mb-5">
                  {{
                    benefit.information.length > 200
                      ? benefit.information.substring(0, 200) + " ..."
                      : benefit.information
                  }}
                </div>
                <v-list subheader two-line dense class="ml-n4">
                  <v-list-item class="mb-n6">
                    <v-list-item-content>
                      <v-list-item-title>Provider</v-list-item-title>
                      <v-list-item-subtitle v-text="benefit.provider_name" />
                    </v-list-item-content>
                  </v-list-item>
                  <!--                  <v-list-item class="mb-n6">-->
                  <!--                    <v-list-item-content>-->
                  <!--                      <v-list-item-title>Cost</v-list-item-title>-->
                  <!--                      <v-list-item-subtitle>-->
                  <!--                        {{ benefit.cost }}{{ benefit.currency }} / {{ benefit.unit }}-->
                  <!--                      </v-list-item-subtitle>-->
                  <!--                    </v-list-item-content>-->
                  <!--                  </v-list-item>-->
                  <!--                  <v-list-item class="mb-n6" v-if="benefit.up_votes">-->
                  <!--                    <v-list-item-content>-->
                  <!--                      <v-list-item-title>Upvotes</v-list-item-title>-->
                  <!--                      <v-list-item-subtitle>-->
                  <!--                        {{ benefit.up_votes }}-->
                  <!--                      </v-list-item-subtitle>-->
                  <!--                    </v-list-item-content>-->
                  <!--                  </v-list-item>-->
                  <v-list-item class="mb-n6">
                    <v-list-item-content>
                      <v-list-item-title>Category</v-list-item-title>
                      <v-list-item-subtitle v-text="benefit.category" />
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-card-title>
          </v-card>
          <v-card-actions class="card-actions">
            <v-btn text @click="showBenefit(benefit.id)" class="theme-text"
              >read more</v-btn
            >
          </v-card-actions>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Component } from "@/views/component";

export default {
  name: "HorizontalCard",
  props: ["benefit"],
  data: () => ({
    defaultImageSrc: "https://cdn.vuetifyjs.com/images/parallax/material2.jpg",
  }),
  computed: {
    ...mapGetters(["userInfo", "companyInfo"]),
  },
  methods: {
    upvote() {
      if (this.benefit.is_favorite) {
        return false;
      }

      let data = {
        benefit_id: parseInt(this.benefit.id),
        user_id: parseInt(this.userInfo.userID),
        provider_id: parseInt(this.benefit.provider_id),
        company_id: parseInt(this.companyInfo.companyId),
        benefit_name: this.benefit.name,
        user_name: this.userInfo.username,
        provider_name: this.benefit.provider_name,
        company_name: this.companyInfo.name,
      };

      this.$store.dispatch(Actions.Benefits.UpvoteOffer, data);
      this.benefit.is_favorite = true;
    },
    showBenefit(id) {
      if (!id) return false;
      this.$router.push({
        name: Component.Protected.Benefit.OnBoarding,
        params: { id: id },
      });
    },
  },
};
</script>

<style scoped>
.border-right {
  border-right: solid lightgrey 1px;
}
.card-actions {
  position: absolute;
  bottom: 0;
}
</style>